import React from 'react';
import { useEffect, useState } from 'react';
import { messaging, onMessage } from "../services/firebase";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const NotificationHandler = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [popupData, setPopupData] = useState({ title: '', body: '', device_id: '', deviceName: '' });
    const { t } = useTranslation();
  
    const isAuthenticated = useSelector((state: any) => !!state.user.accessToken);
  
    useEffect(() => {
      if (!isAuthenticated) return;
  
      const unsubscribe = onMessage(messaging, (payload) => {
        // console.log('payload', payload);
        if (payload?.notification && payload?.data) {
          if (payload.notification.title !== 'New User Registration') {
            setPopupData({
              title: payload.notification.title ?? '',
              body: payload.notification.body ?? '',
              device_id: payload.data.deviceId ?? '',
              deviceName: payload.data.deviceName ?? '',
            });
            setShowPopup(true);
          }

          new Notification(payload.notification.title ?? '', {
            body: payload.notification.body ?? '',
          });
  
          // Auto-close after 5 seconds
        //   setTimeout(() => setShowPopup(false), 5000);
        }
      });
  
      return () => unsubscribe();
    }, [isAuthenticated]);

  return (
    <>
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-30">
          <div className="relative bg-white p-6 rounded-xl shadow-xl max-w-md w-full text-center">
            {/* Close button */}
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-3 right-4 text-black text-xl font-bold hover:text-gray-700"
            >
              &times;
            </button>

            {/* Warning Icon */}
            <div className="flex justify-center mb-4">
              <svg
                className="w-10 h-10 text-red-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.72-1.36 3.485 0l6.518 11.591c.75 1.334-.214 2.99-1.742 2.99H3.48c-1.528 0-2.492-1.656-1.742-2.99L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-.25-6.75a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
                  clipRule="evenodd"
                />
              </svg>
            </div>

            {/* Title and Message */}
            <h2 className="text-md font-semibold text-gray-800 mb-2">
              {popupData.title}
            </h2>
            <h2 className="text-md font-semibold text-gray-800 mb-2">{t('Device ID')}: {popupData.device_id}</h2>
            <h2 className="text-md font-semibold text-gray-800 mb-2">{t('Device Name')}: {popupData.deviceName}</h2>
            <p className="text-md text-gray-700">{popupData.body}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationHandler;